import { Page } from 'orders/schema'
import { t } from 'translations'

export type ModalType = 'details' | 'message' | 'reject' | 'refund'
export type DisputeReason =
    | 'MERCHANDISE_OR_SERVICE_NOT_RECEIVED'
    | 'MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED'
    | 'UNAUTHORISED'
    | 'CREDIT_NOT_PROCESSED'
    | 'DUPLICATE_TRANSACTION'
    | 'INCORRECT_AMOUNT'
    | 'PAYMENT_BY_OTHER_MEANS'
    | 'CANCELED_RECURRING_BILLING'
    | 'PROBLEM_WITH_REMITTANCE'
    | 'OTHER'
export type DisputeStatus =
    | 'WAITING_FOR_SELLER_RESPONSE'
    | 'WAITING_FOR_BUYER_RESPONSE'
    | 'UNDER_REVIEW'
    | 'OPEN'
    | 'RESOLVED'
    | 'OTHER'

export interface RefundPaypalDetails {
    id: string
    accountName: string
    location: string
    reason: string
    refundAmount: number
}

export const getDisputeReasonLabel = (reason: DisputeReason): string => {
    switch (reason) {
        case 'MERCHANDISE_OR_SERVICE_NOT_RECEIVED':
            return t('orders.paypalDisputes.reasons.notReceived')
        case 'MERCHANDISE_OR_SERVICE_NOT_AS_DESCRIBED':
            return t('orders.paypalDisputes.reasons.notAsDescribed')
        case 'UNAUTHORISED':
            return t('orders.paypalDisputes.reasons.unauthorised')
        case 'CREDIT_NOT_PROCESSED':
            return t('orders.paypalDisputes.reasons.creditNotProcessed')
        case 'DUPLICATE_TRANSACTION':
            return t('orders.paypalDisputes.reasons.duplicateTransaction')
        case 'INCORRECT_AMOUNT':
            return t('orders.paypalDisputes.reasons.incorrectAmount')
        case 'PAYMENT_BY_OTHER_MEANS':
            return t('orders.paypalDisputes.reasons.paymentByOtherMeans')
        case 'CANCELED_RECURRING_BILLING':
            return t('orders.paypalDisputes.reasons.canceledRecurringBilling')
        case 'PROBLEM_WITH_REMITTANCE':
            return t('orders.paypalDisputes.reasons.problemWithRemittance')
        case 'OTHER':
            return t('orders.paypalDisputes.reasons.other')
        default:
            return ''
    }
}

export const getDisputeStatusLabel = (status: DisputeStatus): string => {
    switch (status) {
        case 'WAITING_FOR_SELLER_RESPONSE':
            return t('orders.paypalDisputes.statuses.waitingForSeller')
        case 'WAITING_FOR_BUYER_RESPONSE':
            return t('orders.paypalDisputes.statuses.waitingForBuyer')
        case 'UNDER_REVIEW':
            return t('orders.paypalDisputes.statuses.underReview')
        case 'OPEN':
            return t('orders.paypalDisputes.statuses.open')
        case 'RESOLVED':
            return t('orders.paypalDisputes.statuses.resolved')
        case 'OTHER':
            return t('orders.paypalDisputes.statuses.other')
        default:
            return ''
    }
}

export interface Message {
    content: string
    postedAt: string
    postedBy: 'BUYER' | 'SELLER'
}

export interface Dispute {
    account: {
        slug: string
        name: string
    }
    amount: string
    currency: string
    disputeId: string
    id: string
    order: {
        number: string
        email: string
        status: string
        location: string
    }
    reason: DisputeReason
    status: DisputeStatus
    openedAt: string
    responseDueDate: string
    updatedAt: string
    messages: Message[]
    updatedBy: string
}

export interface DisputeDetails extends Dispute {
    messages: Message[]
}

export interface PaypalDisputesPage extends Page {
    entries: Dispute[]
}
